import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import {
  createConsumoIA,
  getConsumoIA,
  getResumenProveedor,
  updateConsumoIA,
} from '../api/consumoIAApi'
import type { ConsumoIACreateInput, ConsumoIAFilters, ConsumoIAUpdateInput } from '../types/consumoIA'

export const consumoIAKeys = {
  all: ['consumo-ia'] as const,
  lists: () => [...consumoIAKeys.all, 'list'] as const,
  list: (filters?: ConsumoIAFilters) => [...consumoIAKeys.lists(), { filters }] as const,
  resumen: (filters?: ConsumoIAFilters) => [...consumoIAKeys.all, 'resumen', { filters }] as const,
}

export function useConsumoIA(filters?: ConsumoIAFilters) {
  return useQuery({
    queryKey: consumoIAKeys.list(filters),
    queryFn: () => getConsumoIA(filters),
  })
}

export function useResumenProveedor(filters?: ConsumoIAFilters, enabled = true) {
  return useQuery({
    queryKey: consumoIAKeys.resumen(filters),
    queryFn: () => getResumenProveedor(filters),
    enabled,
  })
}

export function useCreateConsumoIA() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: ConsumoIACreateInput) => createConsumoIA(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: consumoIAKeys.lists() })
      queryClient.invalidateQueries({ queryKey: consumoIAKeys.all })
      toast.success('Registro creado exitosamente')
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al crear registro')
    },
  })
}

export function useUpdateConsumoIA() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: ConsumoIAUpdateInput }) =>
      updateConsumoIA(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: consumoIAKeys.all })
      toast.success('Registro actualizado exitosamente')
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.error || 'Error al actualizar registro')
    },
  })
}
